import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Decision } from '../../../utilities/Dialog/QuickDialog';
import { MapWindowDialogComponent } from '../map-window-dialog/map-window-dialog.component';

@Component({
  selector: 'app-decision-dialog',
  templateUrl: './decision-dialog.component.html',
  styleUrls: ['./decision-dialog.component.css']
})
export class DecisionDialogComponent implements OnInit {

  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<DecisionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Decision) {

    }


  ngOnInit(){

  }

  onOptionSelected(optioncode){
    this.dialogRef.close(optioncode);
  }
  isDangerMessage(): boolean {
  if (!this.data || !this.data.message) return false;
  const dangerWords = ['delete', 'remove'];
  const msg = this.data.message.toLowerCase();
  return dangerWords.some(word => msg.includes(word));
}
}

